import React, { Component } from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import { BeatLoader } from 'react-spinners';
import { css } from "@emotion/core";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {confirmAlert} from 'react-confirm-alert';
import jwt_decode from "jwt-decode";
import { Collapse, Label, Button, Input, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import * as moment from "moment";
import "../../assets/css/invoice-process.css";
import ModalD from "react-awesome-modal";
import DatePicker from "react-datepicker";
import upRight from "../../assets/img/upRight.png";
import Dropzone from 'react-dropzone';
import $ from "jquery";
import Select from "react-select";
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from "react-virtualized";
import gstDetails from '../../assets/GST_details.csv';
import gstMap from '../../assets/GST_map.csv';
import NTCR from '../../assets/NTCR.csv';
import Churned_Btid from '../../assets/Churned_Btid.csv';
import Churned_Utid from '../../assets/Churned_Utid.csv';
var timestamp = new Date().getTime();
const queryString = require('query-string');
var yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var todayDate = new Date();
var minDate = new Date('2020-01-01');
var timestamp = new Date().getTime();
var yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');

const override = css`
    display: block;
    border-color: red;
    text-align:center;
    margin-top: 3px;
`;
function addslashes( str ) {
    return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
}
function getLastDate(month){
    if(month=='01' || month=='03' || month=='05' || month=='07' || month=='08' || month=='010' || month=='12'){
       return "31";
    } else if(month=='02') {
        return "28";
    } else {
        return "30";
    }
}
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}

function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}

var prevMonthName  = moment().subtract(1, "month").format('MMMM');
var monthDefaults  = moment().subtract(1, "month").format('MM');
var yearDefault  = moment().subtract(1, "month").format('YYYY');
// alert(monthDefaults);
// alert(yearDefault);
// let dateDefault = new Date(); 
// let monthd = dateDefault.setMonth(dateDefault.getMonth() -1);
// dateDefault = dateDefault.toDateString();
// dateDefault = new Date(dateDefault);
// let monthDefaults = getMonth(dateDefault); alert(monthDefaults);
// let yearDefault= dateDefault.getFullYear();
let lastdate = getLastDate(monthDefaults);
let start_date =  yearDefault+'-'+monthDefaults+'-'+"01 00:00:00";
let end_date =  yearDefault+'-'+monthDefaults+'-'+lastdate+" 00:00:00";
let month_years = "" +monthDefaults+yearDefault;
// alert(month_years)
const months = new Array("01", "02", "03", "04", "05", "06",
    "07", "08", "09", "10", "11", "12"
);
var timestamp = new Date().getTime();
var monthOptions = [];
var monthName = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
var d = new Date();

d.setDate(1);
var curr_yr = d.getFullYear();
var prevMonth = monthName[d.getMonth()-1]
for (var i=0; i<=11; i++) {
        monthOptions.push({ value: months[d.getMonth()]+d.getFullYear(), label: monthName[d.getMonth()] + ' ' +d.getFullYear() })
        d.setMonth(d.getMonth() - 1);
}
monthOptions.shift();

let shortMonth = moment(monthDefaults, 'MM').format('MMMM'); // September
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class InvoiceProcess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            loader: true,
            _notificationSystem: null,
            id: null,
            bankValue: null,
            statusValue: null,
            dateTo: tod,
            dateLimit: date_limit,
            dateFromLimit: start_date_limit,
            dateToShow: todShow,
            todSend: todSend,
            yestSend: yestSend,
            datefrom: yest,
            datefromShow: yestShow,
            notificationMsg: '',
            sending: null,
            notifications: [],
            monthValue: { value: month_years, label: prevMonth+" "+curr_yr},
            monthID: month_years,
            upload_ntcr_data_status: 'No file chosen',
            ntcrFiles:[],
            upload_btid_data_status: 'No file chosen',
            btidFiles:[],
            uploaded_file_status:'No file chosen',
            files:[],
            bankStatementFiles: [],
            bank_statement_file_status: 'No file chosen',
            UTIDsFiles: [],
            UTIDs_file_status: 'No file chosen',
            gstFiles: [],
            upload_gst_data_status: 'No file chosen',
            partyCodeFiles: [],
            upload_party_code_data_status: 'No file chosen',
            accept_run_invoice: false,
            accept_send_invoice: false,
            selected_date: moment(todayDate).format('DD/MM/YY'),
            model_visible : false,
            unlock_bank_upload:false,
            bank_unlock_password:'',
            master_data:[],
            ft_all_steps:[],
            curr_step_num:1,
            curr_step_name:'import_txn',
            curr_step_status:'initiated',
            invoice_master_id:'',
            kpiData: [],
            notif_loading:false,
            active_index:0,
            unsettleShowHide:"none",
            changedItems:[],
            allUnsetteleditems:[],
            model_Mismach:false,
            transaction_records:[],
            messages:'',
            total_txn:'',
            total_txn_amount:'',
            total_ft_amount:'',
            is_records: false,
            include_kycsuccess:0,
            mpr_conf_list:[],
            mpr_config_id:'',
            all_master_id:[],
            cb_bankstmt_upload:false,
            start_date:start_date,
            end_date:end_date,
            month_name:shortMonth,
            year_name:yearDefault,
            entity_identifier: {},
            merchantList:[],
            chainList:[],
            merchantID:[],
            chainID:[],
            acqBankList: [{value: '', label: 'Select Bank'}],
            acqBankValue: null,
            acq_bank_id: [],
            merchantValue:null,
            chainValue:null,
            bankValue:null,
            storeID:[],
            storeValue:'',
            storeList:[],
            is_store_loading: true,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code: [],
            storeObject: [],
            search_object_code:[],
            total_txn:"--",
            churned_utid:"--",
            new_utid_configured:"--",
            churned_btid:"--",
            utid_gst_missing:"--",
            invoice_running_status:'pending',
            generate_invoice_file: 'pending',
            is_download_invoice_file: false,
            invoice_excel_path:'',
            loading1:false,
            is_prev_month:false

        }
        
    }
    
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_email: decoded.email,
            userSubGroupName: decoded.userSubGroupName,
            userType: decoded.userType
        })
        this.get_product_master(this.state.monthID);
        this.get_parameters();
        //this._getAllMerchants();
        this.get_run_invoice_status('','','','','');
        //this.get_generate_file_status('','','','','');
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        
    }

    
    get_parameters(s_date){
        axios.get(config.get('API_URL') + '/invoice/get_parameters/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
               
            }
        }).then(response => {
            console.log(response.data.entity_identifier);  
            this.setState({
                entity_identifier: response.data.entity_identifier
            })         
        });
    
    }
    get_product_master(for_month){ //alert(for_month);
        disabledBody()
        axios.post(config.get('API_URL')+'/invoice/get_product_master/',{
                for_month: for_month,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
             console.log("ppppp"); console.log(response.data);
            if (Array.isArray(response.data) && response.data.length>0) {

                this.get_all_steps(response.data[0].invoice_master_id)
            } else {
                this.ft_initialize(for_month);
            }
            var all_master_id = [];
            response.data.map((data, index) => { //console.log("nnnnnnnnnn"); console.log(data.ft_master_id)
                all_master_id.push(data.invoice_master_id);
            })
            this.setState({
                master_data: response.data,
                all_master_id: all_master_id,
                loading: false
            })
        });
    }

    

    
    get_all_steps(invoice_master_id){
        this.setState({
            invoice_master_id:invoice_master_id
        })
        disabledBody()
        axios.post(config.get('API_URL')+'/invoice/get_all_steps/',{
                ft_master_id: invoice_master_id,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            //console.log("allSteps"); console.log(response.data);
            this.get_current_state('','','','','')
            this.setState({
                ft_all_steps: response.data,
                loading: false
            })
            enabledBody();


        });
    }
    ft_initialize(for_month){
        disabledBody()
        axios.post(config.get('API_URL')+'/invoice/ft_initialize/',{
                ft_date: for_month,
                update_by:this.state.user_email
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            this.get_product_master(for_month);
            this.setState({
                loading: false
            })

            enabledBody();
        });
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-bell" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    get_current_state(step_name, step_num,invoice_process_id, job_type, e){ //alert(invoice_process_id)
        disabledBody()
        axios.post(config.get('API_URL')+'/invoice/get_curr_state/',{
                for_month: this.state.monthID,
                invoice_master_id :this.state.invoice_master_id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => { //console.log("curr_state",response.data);
                this.setState({
                    curr_step_num:response.data.data.step_num,
                    //curr_step_num:4,
                    curr_step_name:response.data.data.step_name,
                    curr_step_status:response.data.data.status,
                    is_import_transaction:response.data.data.import_transaction,
                    is_import_churn_utids:response.data.data.import_churn_utids,
                    is_import_ntcr_data:response.data.data.import_ntcr_data,
                    is_import_churn_btids:response.data.data.import_churn_btids,
                    is_gst_mapping:response.data.data.gst_mapping,
                    is_party_code_upload:response.data.data.party_code_upload,
                    is_gst_upload:response.data.data.gst_upload,
                    total_txn:response.data.data.total_txn,
                    churned_utid:response.data.data.churned_utid,
                    new_utid_configured:response.data.data.new_utid_configured,
                    churned_btid:response.data.data.churned_btid,
                    utid_gst_missing:response.data.data.utid_gst_missing,
                    is_download_invoice_file:response.data.data.is_download_invoice_file,
                    invoice_excel_path:response.data.data.invoice_excel_path,
                    generate_invoice_file:response.data.data.generate_invoice_status
                })
                //alert(response.data.data.invoice_excel_path);
                this.setState({
                    loading: false
                })

            enabledBody();
                if(response.data.data.step_num===step_num && job_type==='prev'){
                    this.get_prev_step(response.data.data.step_num,invoice_process_id)
                }
                if(response.data.data.step_name==='import_txn' && job_type===''){
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else {
                            this.handleNotificationClick("tr", 3, "Import Transaction yet to be done");
                        }
                    }
                }
                if(response.data.data.step_name==='import_churn_utid' && job_type===''){
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else {
                            this.handleNotificationClick("tr", 3, "Please Upload Churned UTIDs");
                        }
                    }
                }
                if(response.data.data.step_name==='import_ntcr_data' && job_type===''){
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else {
                            this.handleNotificationClick("tr", 3, "Please Upload NTCR Data");
                        }
                    }
                }
                if(response.data.data.step_name==='import_churn_btid' && job_type===''){
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else {
                            this.handleNotificationClick("tr", 3, "Please Upload Churned BTIDs");
                        }
                    }
                }
                if(response.data.data.step_name==='gst_mapping' && job_type===''){ 
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else { 
                        
                            if(response.data.data.gst_upload===false){
                                this.handleNotificationClick("tr", 3, "Please Upload GST");
                            } else if(response.data.data.party_code_upload===false){
                                this.handleNotificationClick("tr", 3, "Please Upload Party Code");
                            }
                            
                        }
                    }
                }
                
                if(response.data.data.step_name==='run_invoice' && job_type===''){
                   
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else {
                            if(this.state.invoice_running_status==='pending'){
                                this.handleNotificationClick("tr", 3, "Please run invoice");
                            } else if(this.state.invoice_running_status==='running'){
                                this.handleNotificationClick("tr", 3, "invoice running");
                               
                            }
                            else if(this.state.invoice_running_status==='failed'){
                                this.handleNotificationClick("tr", 3, "Please rerun invoice");
                               
                            }
                            else if(this.state.invoice_running_status==='stopped'){
                                this.handleNotificationClick("tr", 3, "Please rerun invoice");
                               
                            }
                            else if(this.state.invoice_running_status==='success'){
                               this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                               
                            }
                            
                        }
                    }
                }
                if(response.data.data.step_name==='download_inv_file' && job_type===''){
                   
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else {
                            if(this.state.generate_invoice_file==='pending' || this.state.generate_invoice_file==='' || this.state.generate_invoice_file=== null || this.state.generate_invoice_file==='null'){
                                this.handleNotificationClick("tr", 3, "Please generate invoice");
                            } else if(this.state.generate_invoice_file==='running'){
                                this.handleNotificationClick("tr", 3, "Waiting for generate invoicer file.");
                               
                            }
                            else if(this.state.generate_invoice_file==='failed'){
                                this.handleNotificationClick("tr", 3, "Please re-generate invoice");
                               
                            }
                            else if(this.state.generate_invoice_file==='stopped'){
                                this.handleNotificationClick("tr", 3, "Please re-generate invoice");
                               
                            }
                            else if(this.state.generate_invoice_file==='success'){
                             
                               if(this.state.is_download_invoice_file===false){
                                this.handleNotificationClick("tr", 3, "Invoice file has been generated. Please download");
                               }
                               if(this.state.is_download_invoice_file===true){
                                this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                               }
                               
                            }
                            
                        }
                    }
                }
                if(response.data.data.step_name==='invoice_sent' && job_type===''){ 
                    if(response.data.data.step_num===step_num){
                        if(response.data.data.status==='completed'){
                            //this.get_next_step(response.data.data.step_num,'completed',invoice_process_id);
                        } else { 
                        
                            if(this.state.accept_send_invoice===false){
                                let er = "Please confirm that the invoices are shared with all the parties.";
                                this.handleNotificationClick("tr", 3, er);
                                return false;
                            } else {
                                this.update_last_step(response.data.data.step_num,'completed',invoice_process_id);
                            }
                            
                        }
                    }
                }
                if(job_type==='import-transaction'){
                    if(response.data.data.import_transaction===false){
                        this.callJobs( "import-transaction", response.data.data.step_num,'completed',invoice_process_id);
                    }
                    else {
                        //this.handleNotificationClick("tr", 3, "MPR not uploaded.");
                    }
                }
                if(job_type==='import_churn_utid'){
                    if(response.data.data.import_churn_utids===false){
                        this.upload_churned_utids(response.data.data.step_num,'completed',invoice_process_id);
                    }
                    else {
                        //this.handleNotificationClick("tr", 3, "MPR not uploaded.");
                    }
                }
                if(job_type==='import_ntcr_data'){
                    if(response.data.data.import_ntcr_data===false){
                        this.upload_ntcr_data(response.data.data.step_num,'completed',invoice_process_id);
                    }
                    else {
                        //this.handleNotificationClick("tr", 3, "MPR not uploaded.");
                    }
                }
                if(job_type==='import_churn_btid'){ 
                    if(response.data.data.import_churn_btids===false){
                        this.upload_churned_btid(response.data.data.step_num,'completed',invoice_process_id);
                    }
                    else {
                        //this.handleNotificationClick("tr", 3, "MPR not uploaded.");
                    }
                }
                if(job_type==='gst_upload' ||  job_type==='party_code_upload'){ 
                    if(response.data.data.gst_mapping===false){
                        this.upload_gsts(response.data.data.step_num,'completed',invoice_process_id,job_type);
                    }
                    else {
                        //this.handleNotificationClick("tr", 3, "MPR not uploaded.");
                    }
                }
                if(job_type==='run_invoice'){ 
             
                    if(this.state.accept_run_invoice===false){
                        let er = "Please confirm to run the invoice for the month of "+this.state.month_name+" "+this.state.year_name;
                        this.handleNotificationClick("tr", 3, er);
                        return false;
                    }
                    if(this.state.invoice_running_status==='running'){
                        this.handleNotificationClick("tr", 3, "invoice is running.");
                    }
                    else {
                        this.run_invoice(response.data.data.step_num,'completed',invoice_process_id,job_type);
                    }
                }

                if(job_type==='download_inv_file'){ 
             
                    if(this.state.generate_invoice_file==='pending' || this.state.generate_invoice_file==='' || this.state.generate_invoice_file==='failed' || this.state.generate_invoice_file==='stopped' || this.state.generate_invoice_file=== null || this.state.generate_invoice_file==='null'){
                        this.generate_invoice_file(response.data.data.step_num,'completed',invoice_process_id,job_type);
                    }
                    else if(this.state.generate_invoice_file==='running'){
                        this.handleNotificationClick("tr", 3, "Waiting for generate invoice file.");
                    }
                    else {
                        this.handleNotificationClick("tr", 3, "Invoice file has been generated. Please download");
                    }
                }
        });
    }
    onPreviewDrop = (files) => {
        
        let fileData = [];
        fileData = files;

        if (files.length > 0) {
            this.setState({
                btidFiles: fileData,
                upload_btid_data_status: files[0].name,
            });
        }
        else {

            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    onPreviewDropUTIDs = (files) => {
        let fileData = [];
        fileData = files;

        if (files.length > 0) {
            this.setState({
                UTIDsFiles: fileData,
                UTIDs_file_status: files[0].name,
                // file_label: true,
                // recon_status: null,
                // checkTable: false
            });
        }
        else {
            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    onPreviewDropGst = (files) => {
        
        let fileData = [];
        fileData = files;

        if (files.length > 0) {
            this.setState({
                gstFiles: fileData,
                upload_gst_data_status: files[0].name,
            });
        }
        else {

            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    onPreviewDropPartyCode = (files) => {
        
        let fileData = [];
        fileData = files;

        if (files.length > 0) {
            this.setState({
                partyCodeFiles: fileData,
                upload_party_code_data_status: files[0].name,
            });
        }
        else {

            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    get_next_step(step_num,status,invoice_process_id){
    
        disabledBody()

        this.setState({
            loading:true
        })
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/invoice/update_steps/', {
                insert_update: "update_timeseries_invprocess",
                invoice_master_id :this.state.invoice_master_id,
                updated_by: decoded.email,
                updated_at:new Date(),
                invoice_process_id: invoice_process_id,
                step_no: step_num,
                status: status,
                is_current_status: true,
                for_month: this.state.monthID,
                inv_date:todSend
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            //console.log("tessssssssssss"); console.log(response.data);
            this.get_current_state('','','','','')
            enabledBody();
        });

    }
    get_prev_step(step_num,invoice_process_id){
       
        disabledBody()

        this.setState({
            loading:true
        })
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/invoice/update_prev_steps/', {
                
                invoice_master_id :this.state.invoice_master_id,
                updated_by: decoded.email,
                updated_at:new Date(),
                invoice_process_id: invoice_process_id,
                step_no: step_num,
                
                for_month: this.state.monthID,
                inv_date:todSend
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            //console.log("tessssssssssss"); console.log(response.data);
            this.get_current_state('','','','','')
            enabledBody();
        });

    }
    update_last_step(step_num,status,invoice_process_id){
    
        disabledBody()

        this.setState({
            loading:true
        })
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/invoice/update_last_step/', {
                insert_update: "update_timeseries_invprocess",
                invoice_master_id :this.state.invoice_master_id,
                updated_by: decoded.email,
                updated_at:new Date(),
                invoice_process_id: invoice_process_id,
                step_no: step_num,
                status: status,
                is_current_status: true,
                for_month: this.state.monthID,
                inv_date:todSend
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            //console.log("tessssssssssss"); console.log(response.data);
            this.get_current_state('','','','','')
            enabledBody();
        });

    }

    onPreviewDropNtcr  = (files) => {
        let fileData = [];
        fileData = files;
        //console.log(files);
        if (files.length > 0) {
            this.setState({
                ntcrFiles: fileData,
                upload_ntcr_data_status: files[0].name,
            });

            //console.log(this.state.files)
        }
        else {
            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    upload_ntcr_data(step_name, step_num,invoice_process_id,e) {

        if (this.state.upload_ntcr_data_status === 'No file chosen') {
            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
            return false;
        }
        this.setState({
            loading:true
        })

        var data = new FormData();
        data.append('uploaded_by', this.state.user_email);
        data.append('file', this.state.ntcrFiles[0]);
        data.append('invoice_master_id', this.state.invoice_master_id);
        data.append('for_month', this.state.monthID);
        data.append('start_date', this.state.start_date);
        data.append('end_date',this.state.end_date);

       axios.post(config.get('API_URL')+"/invoice/upload_ntcr_file/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                if(response.data.data==="Upload successful") {
                    
                    this.handleNotificationClick("tr", 1, response.data.data);
                    this.callJobs( "import_ntcr_data", step_num,'completed',invoice_process_id);
                  
                } else {
                    this.handleNotificationClick("tr", 3, response.data.error);
                }
            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });

    }
    upload_churned_btid(step_name, step_num,invoice_process_id,e) {
         
        if (this.state.upload_btid_data_status === 'No file chosen') {
            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
            return false;
        }
        this.setState({
            loading:true
        })

        var data = new FormData();
        data.append('uploaded_by', this.state.user_email);
        data.append('file', this.state.btidFiles[0]);
        data.append('invoice_master_id', this.state.invoice_master_id);
        data.append('for_month', this.state.monthID);
        data.append('start_date', this.state.start_date);
        data.append('end_date',this.state.end_date);

       axios.post(config.get('API_URL')+"/invoice/upload_churned_btid/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                if(response.data.data==="Upload successful") {
                    
                    this.handleNotificationClick("tr", 1, response.data.data);
                    this.downloadKpiDetails('','')
                  
                } else {
                    this.handleNotificationClick("tr", 3, response.data.error);
                }
                this.setState({
                    loading:false
                })
                enabledBody();
                
               
            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });

    }
    upload_gsts(step_name, step_num,invoice_process_id,job,e) { 
        
        if (this.state.is_gst_upload === true && job==='gst_upload') {
            this.handleNotificationClick("tr", 3, "GST already uploaded");
            return false;
        }
        if (this.state.is_party_code_upload === true && job==='gst_upload') {
            this.handleNotificationClick("tr", 3, "Party Code already uploaded");
            return false;
        }
        if (this.state.upload_gst_data_status === 'No file chosen' && job==='gst_upload') {
            
            this.handleNotificationClick("tr", 3, "Please upload  GST");
            return false;
        }
        if (this.state.upload_party_code_data_status === 'No file chosen' && job==='party_code_upload') {
            this.handleNotificationClick("tr", 3, "Please upload party code");
            return false;
        }
        let sub_entity = "gst-master";
        let uploadFile = this.state.gstFiles[0];
        if(job==='party_code_upload'){
            sub_entity = "gst-master-party-code-mapping";
            uploadFile = this.state.partyCodeFiles[0];
        }
        disabledBody();
        this.setState({
            loading:true
        })

        var data = new FormData();
        data.append('uploaded_by', this.state.user_email);
        data.append('file', uploadFile);
        data.append('sub_entity', sub_entity);
        data.append('entity', "gst-master");
        data.append('invoice_master_id', this.state.invoice_master_id);
        data.append('for_month', this.state.monthID);

       axios.post(config.get('API_URL')+"/invoice/gst_mapping/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                if(response.data.data==="Upload successful") {
                    
                    this.handleNotificationClick("tr", 1, response.data.data);
                   
                  
                } else {
                    this.handleNotificationClick("tr", 3, response.data.error);
                }
                this.setState({
                    loading:false,
                    upload_gst_data_status:'No file chosen',
                    upload_party_code_data_status: 'No file chosen'
                })
                enabledBody();
                this.get_current_state('','','','','');
            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });

    }
    showAlert(step_name, step_num, invoice_process_id, job,e) { 
        confirmAlert({
            title: 'Warning',
            message: "Are you sure want to move previous step? it will revert all the data",
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.get_current_state(step_name, step_num, invoice_process_id,job,e);
                }
            },
                {
                    label: 'No',
                },
                
            ]
        });
    }

    handleCheckbox_run_invoice(e) {
        if (e.target.checked === true) {
            this.setState({accept_run_invoice: true})

        } else {
            this.setState({accept_run_invoice: false});

        }

    }
    handleCheckbox_send_invoice(e) {
        if (e.target.checked === true) {
            this.setState({accept_send_invoice: true})

        } else {
            this.setState({accept_send_invoice: false});

        }

    }
   
    upload_churned_utids(step_num, status, ft_process_id,e){
        if(this.state.is_import_churn_utids===true) {
            this.handleNotificationClick("tr", 3, "Churned UTIDs already Uploaded");
            return false;
        }
        if (this.state.UTIDs_file_status === 'No file chosen') {
            this.handleNotificationClick("tr", 3, "Please upload a valid file");
            return false;
        }
        this.setState({
            loading:true
        })
        disabledBody();
        var data = new FormData();

        data.append('file', this.state.UTIDsFiles[0]);
        // data.append('bank_code', 'HDFC');
        data.append('invoice_master_id', this.state.invoice_master_id);
        data.append('for_month', this.state.monthID);
        data.append('uploaded_by',this.state.user_email);
        data.append('start_date', this.state.start_date);
        data.append('end_date',this.state.end_date);
       
        axios.post(config.get('API_URL')+"/invoice/upload_churned_utids/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                //console.log(response.data.data);
                if(response.data.data==="Upload successful") {
                    
                    this.handleNotificationClick("tr", 1, response.data.data);
                  
                } else {
                    this.handleNotificationClick("tr", 3, response.data.error);
                }
                this.setState({
                    loading:false
                })
                enabledBody();
                this.get_current_state('','','','','');

            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    
    
    downloadInvoiceFile(step_name, step_num,invoice_process_id,job,e){
        //alert(this.state.invoice_excel_path);
        if(this.state.invoice_excel_path==="" || this.state.invoice_excel_path==="nul" || this.state.invoice_excel_path===null) {
             this.handleNotificationClick("tr", 3, "File path is empty");
             return false;
        }
        var that = this;
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        let postData = {
            file_path: this.state.invoice_excel_path
        }
        $.ajax({
            url: config.get('API_URL') + "/invoice/download_invoice_file",
            type: "POST",
            data: postData,
            xhrFields: {
                responseType: 'blob'
            },
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = "invoice_"+that.state.monthID+".zip";
                console.log(fileName);

                let rfile = fileName.replace(/\"/g, "");

                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                that.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile,

                })
                that.update_tm_master();

            }

        });
    }

    update_tm_master(){
        let data = {
            for_month: this.state.monthID,
            invoice_master_id: this.state.invoice_master_id
        }
        axios.post(config.get('API_URL')+"/invoice/update_tm_master/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {

                this.get_current_state('','','','','');

            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });

    }

    callJobs(type, step_num, status, ft_process_id, e) { // alert(type);
        disabledBody();
        axios.get(config.get('API_URL') + '/invoice/exc-jobs/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                type: type,
                end_date:this.state.end_date,
                start_date:this.state.start_date,
                invoice_master_id: this.state.invoice_master_id,
                user_email:this.state.user_email
            }
        }).then(response => {

            enabledBody();
            // this.get_kpis(this.state.todSend);
            // this.refresh_product_master();
            this.handleNotificationClick("tr", 1, response.data.data);
            this.get_current_state('','','','','');

        });
    }
    dropBankStatement  = (files) => {
        let fileData = [];
        fileData = files;
        if (files.length > 0) {
            this.setState({
                bankStatementFiles: fileData,
                bank_statement_file_status: files[0].name,
            });

        }
        else {

            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    stepSix(step_num, ft_process_id){

        if (this.state.bank_statement_file_status === 'No file chosen') {
            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
            return false;
        }
        this.setState({
            loading:true
        })
        var data = new FormData();


        data.append('file', this.state.bankStatementFiles[0]);
        data.append('selected_date', this.state.selected_date);
        data.append('batch_id', this.state.todSend.split('-').join(''));
        data.append('ft_master_id', this.state.ft_master_id);
        axios.post(config.get('API_URL')+"/fundtransfer/upload_stmt_file/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {

                this.handleNotificationClick("tr", 1, response.data.data);

                if(response.data.data == 'Data Uploaded Successfully.') {
                    this.get_kpis(this.state.todSend);
                    this.refresh_product_master();
                    this.get_ft_notification_batch('','');
                    this.get_next_step(step_num, 'completed', ft_process_id);
                    //this.get_current_state.bind(this,'upload_bank_stmt', step_num, ft_process_id, '')
                } else {
                    this.handleNotificationClick("tr", 1, "Something went wrong!");

                }

                this.setState({
                    loading:false,
                    uploaded_file_status:'No file chosen'
                })
            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    downloadFile(step_num, ft_process_id,e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);

        if(this.state.model_Mismach===true)
        {
            this.setState({
                model_Mismach:false,
                loading:false
            })

            enabledBody();
        }
        else
        {
            this.setState({
                model_visible: false,
            })

            //this.get_next_step(step_num,'completed',ft_process_id);
        }     
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    downloadKpiDetails(type, e){
            //alert(type);

            var that = this;
            if(type==='download'){
                this.setState({
                    model_Mismach: true,
                    file_url: '',
                    rfile: ''
                });
            }
            //disabledBody();
            $.ajax({
                url: config.get('API_URL') + "/invoice/download_unmapped_utid",
                type: 'GET',
                xhrFields: {
                    responseType: 'blob'
                },
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response, status, xhr) {
                   
    
                    let blob = new Blob([response], {
                        type: "octet/stream"
                    });
                    let fileName = moment(that.state.todSend).format('DD-MM-YYYY') +'_Unmapped_UTIDs.xlsx.gz'
                    // console.log(fileName);
    
                    let rfile = fileName.replace(/\"/g, "");
    
                    // let a = document.createElement('a');
                    let url = window.URL.createObjectURL(blob);
                    //alert(url);
                    // a.href = url;
                    // a.download = rfile;
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                    that.setState({
                        is_download: true,
                        file_url: url,
                        rfile: rfile,
    
                    })
                    if(type==''){
                        that.get_current_state('','','','','');
                    }
                    //enabledBody();
    
                }
    
            });
        
    }
    downloadKpi(type, e){
        //alert(type);

        var that = this;
       
            this.setState({
                model_Mismach: true,
                file_url: '',
                rfile: ''
            });

            let postData = {
                end_date:this.state.end_date,
                start_date:this.state.start_date,
                type:type
            }
        
        //disabledBody();
        let fn = ''
        if(type==='chruned_utid'){
            fn = 'churned_UTIDs.xlsx.gz'
        }
        if(type==='new_utid'){
            fn = 'new_UTIDs.xlsx.gz'
        }
        if(type==='churned_btid'){
            fn = 'deactivated_BTIDs.xlsx.gz'
        }
        $.ajax({
            url: config.get('API_URL') + "/invoice/download_kpis",
            type: 'POST',
            data: postData,
            xhrFields: {
                responseType: 'blob'
            },
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            success: function (response, status, xhr) {
               

                let blob = new Blob([response], {
                    type: "octet/stream"
                    // type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"
                });
                let fileName = moment(that.state.todSend).format('DD-MM-YYYY') +fn;
                // console.log(fileName);

                let rfile = fileName.replace(/\"/g, "");

                // let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                //alert(url);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                that.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile,

                })
               
                //enabledBody();

            }

        });
    
}
    closeMismachModal() {
        this.setState({
            model_Mismach : false
        });
    }
     
    
    changeMonth(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        let month = value.substring(0, 2);
        let year = value.substring(2, 6);
        let lastdatem = getLastDate(month);
        let start_date_m =  year+'-'+month+'-'+"01 00:00:00";
        let end_date_m =  year+'-'+month+'-'+lastdatem+" 00:00:00";
        let is_prev_month = false; 
        if(value===month_years){
            is_prev_month = false; 
        } else {
            is_prev_month = true; 
        }
        //alert(is_prev_month);
        this.setState({
            is_prev_month:is_prev_month,
            monthID: value,
            monthValue:optionSelected,
            start_date: start_date_m,
            end_date: end_date_m,
            month_name:moment(month, 'MM').format('MMMM'),
            year_name:year,
            upload_ntcr_data_status: 'No file chosen',
            ntcrFiles:[],
            upload_btid_data_status: 'No file chosen',
            btidFiles:[],
            uploaded_file_status:'No file chosen',
            files:[],
            bankStatementFiles: [],
            bank_statement_file_status: 'No file chosen',
            UTIDsFiles: [],
            UTIDs_file_status: 'No file chosen',
            gstFiles: [],
            upload_gst_data_status: 'No file chosen',
            partyCodeFiles: [],
            upload_party_code_data_status: 'No file chosen',
            accept_run_invoice: false,
            accept_send_invoice: false,
            selected_date: moment(todayDate).format('DD/MM/YY'),
            model_visible : false,
            unlock_bank_upload:false,
            bank_unlock_password:'',
            master_data:[],
            ft_all_steps:[],
            curr_step_num:1,
            curr_step_name:'import_txn',
            curr_step_status:'initiated',
            invoice_master_id:'',
            kpiData: [],
            notif_loading:false,
            active_index:0,
            unsettleShowHide:"none",
            changedItems:[],
            allUnsetteleditems:[],
            model_Mismach:false,
            transaction_records:[],
            messages:'',
            total_txn:'',
            total_txn_amount:'',
            total_ft_amount:'',
            is_records: false,
            include_kycsuccess:0,
            mpr_conf_list:[],
            mpr_config_id:'',
            all_master_id:[],
            cb_bankstmt_upload:false,
            entity_identifier: {},
            total_txn:"--",
            churned_utid:"--",
            new_utid_configured:"--",
            churned_btid:"--",
            utid_gst_missing:"--",
            invoice_running_status:'pending',
            generate_invoice_file: 'pending',
            is_download_invoice_file: false,
            invoice_excel_path:'',
            loading1:false

        }, () => {
            this.get_product_master(value);    
            this.get_parameters();
            //this._getAllMerchants();
            this.get_run_invoice_status('','','','','');
            //this.get_generate_file_status('','','','','');
        });
        
        

    }
    run_invoice(){ 
        disabledBody();
        let data = {
            invoice_master_id:this.state.invoice_master_id,
            for_month:this.state.for_month,
            start_date:this.state.start_date,
            end_date:this.state.end_date,
            user_email:this.state.user_email,
            entity_identifier:this.state.entity_identifier,
        }
       
        axios.post(config.get('API_URL')+"/invoice/run_invoicing/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                
                    
                    this.handleNotificationClick("tr", 1, response.data.data);
                  
               
                this.setState({
                    loading:false,
                    accept_run_invoice:false
                })
                enabledBody();
                this.check_run_status();
                //this.get_current_state('','','','','');

            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    generate_invoice_file(){ 
        disabledBody();
        let data = {
            invoice_master_id:this.state.invoice_master_id,
            for_month:this.state.for_month,
            start_date:this.state.start_date,
            end_date:this.state.end_date,
            user_email:this.state.user_email,
            entity_identifier:this.state.entity_identifier,
        }
       
        axios.post(config.get('API_URL')+"/invoice/gen-inv-files/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                
                    
                    this.handleNotificationClick("tr", 1, response.data.data);
                  
               
                this.setState({
                    loading:false
                })
                enabledBody();
                this.get_current_state('','','','','');

            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    // get_generate_file_status(step_name, step_num,invoice_process_id, job_type, e){
        
    //     disabledBody();
    //     let data = {
           
    //         start_date:this.state.start_date,
    //         end_date:this.state.end_date,
          
    //     }
       
    //     axios.post(config.get('API_URL')+"/invoice/gen_file_invoicing_status/", data,{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     })
    //         .then((response) => {
                                  
    //             //console.log("sssssssss",response.data);
    //             if(Array.isArray(response.data) && response.data.length) {  
    //                 this.setState({
    //                     generate_invoice_file:response.data[0].status
    //                 })
    //             }
    //             this.setState({
    //                 loading:false
    //             })
    //             enabledBody();
    //             if(job_type==='download_inv_file'){
    //                 setTimeout(function(){
    //                     this.get_current_state(step_name, step_num,invoice_process_id, '', e);
    //                 }.bind(this), 500);
    //             }

    //         })
    //         .catch(function (error) {
    //             console.log("MPR Res : " + error);
    //         });
    // }
    get_run_invoice_status(step_name, step_num,invoice_process_id, job_type, e){
        disabledBody();
        let data = {

            start_date:this.state.start_date,
            end_date:this.state.end_date,

        }
       
        axios.post(config.get('API_URL')+"/invoice/run_invoicing_status/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                                  
                //console.log("sssssssss",response.data);
                if(Array.isArray(response.data) && response.data.length) { //alert(response.data[0].status); alert(job_type);
                    this.setState({
                        invoice_running_status:response.data[0].status
                    })
                }
                this.setState({
                    loading:false
                })
                enabledBody();
                if(job_type==='run_invoice'){
                    setTimeout(function(){
                        this.get_current_state(step_name, step_num,invoice_process_id, '', e);
                    }.bind(this), 500);   
                }


            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    check_run_status(step_name, step_num,invoice_process_id, job_type, e){
        disabledBody();
        let data = {

            start_date:this.state.start_date,
            end_date:this.state.end_date,

        }
       
        axios.post(config.get('API_URL')+"/invoice/run_invoicing_status/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                                  
                //console.log("sssssssss",response.data);
                if(Array.isArray(response.data) && response.data.length) { //alert(response.data[0].status); alert(job_type);
                    this.setState({
                        invoice_running_status:response.data[0].status
                    })
                }
                this.setState({
                    loading:false
                })
                enabledBody();
                
                    setTimeout(function(){
                        this.get_current_state('','','','','');
                    }.bind(this), 500);   
                


            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    changePass(e){
        this.setState({
            bank_unlock_password: e.target.value
        })
    }
    unlockBankUpload(){
        if(this.state.bank_unlock_password===''){
            this.handleNotificationClick("tr", 3, "Please enter password");
            return false;
        }
        let data = {}
        axios.post(config.get('API_URL')+"/invoice/get_inv_pass/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {

                if(response.data.data===this.state.bank_unlock_password){
                    this.setState({
                        is_prev_month:false,
                    })
                } else{
                    this.handleNotificationClick("tr", 3, "Invalid password");
                }


            })
            .catch(function (error) {
                console.log("MPR Res : " + error);
            });
    }
    render() {
        console.log("kkkkkkkkkk", this.state.start_date, this.state.end_date)
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if (rows.length !== undefined) {
                no_of_rows = rows.length;
                if (no_of_rows < 9) {
                    drop_down_heigth = 40 * no_of_rows;
                } else {
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
                <div key={key} style={style}>{rows[index]}</div>
            );
            return (
                <List
                    style={{width: '100%'}}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        console.log(this.state.entity_identifier)
        console.log(this.state.start_date);
        console.log(this.state.end_date);
        const transaction_records = this.state.transaction_records.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.utid}</td>
                    <td className="align-right">{data.utid_total_txn}</td>
                    <td className="align-right">{data.utid_total_txn_amount}</td>
                    <td className="align-right">{data.utid_total_ft_amount}</td>

                </tr>
            )
        });

        const steps_menu_bind = this.state.ft_all_steps.map((data, index) => {
            return (
                <div
                    className="rc-steps-item rc-steps-item-wait">
                    <div className="rc-steps-item-container">
                        {data.step_num<8?
                        <div className="rc-steps-item-tail"></div>:null}
                        {data.step_num===this.state.curr_step_num && data.step_name!=='invoice_sent'?
                            <div className="rc-steps-item-icon-active"><span
                                className="rc-steps-icon">{data.step_num}</span>
                            </div> :null}
                        {data.step_name==='invoice_sent'?
                            <React.Fragment>
                            {this.state.curr_step_num==data.step_num  && this.state.curr_step_status==='completed'?
                                <div className="rc-steps-item-icon-done"><span
                                    className="rc-steps-icon"><i className="fa fa-check" aria-hidden="true"></i></span>
                                </div>
                                :null}
                                {this.state.curr_step_num==data.step_num  && this.state.curr_step_status==='initiated'?
                                <div className="rc-steps-item-icon-active"><span
                                className="rc-steps-icon">{data.step_num}</span>
                                </div>
                                :null}
                                </React.Fragment>
                            :null
                        }
                        {this.state.curr_step_num>data.step_num?
                            <div className="rc-steps-item-icon-done"><span
                                className="rc-steps-icon"><i className="fa fa-check" aria-hidden="true"></i></span>
                            </div> :null}

                        {this.state.curr_step_num<data.step_num?
                            <div className="rc-steps-item-icon"><span
                                className="rc-steps-icon">{data.step_num}</span>
                            </div> :null}
                        <div className="rc-steps-item-content">
                            <div className="rc-steps-item-title">{data.step_display_name}</div>
                            {/*<p className="font-10">Last Updated 10 min ago</p>*/}
                        </div>
                    </div>
                </div>


            )
        });
        

        const steps_content_bind = this.state.ft_all_steps.map((data, index) => {

            return (
              <div>
                  {this.state.is_prev_month===true && index===0?
                  <div className="row" style={{minHeight:440}}>
                  <div className="overlay">
                  </div>
                  <div className="col-md-2">
                  </div>
                  <div className="col-md-8 unlockForm s-r-con">
                      <i className="fa fa-lock"></i>
                      <Input placeholder="xxxx" name="bank_upload_pass" type="password" className="unlock-input" value={this.state.password} onChange={this.changePass.bind(this)}/>
                      <button type="button" className="primary rc-unlock-btn" role="button" onClick={this.unlockBankUpload.bind(this,'Beneficiary setup')}  >Unlock</button>

                  </div>
                  <div className="col-md-2">
                  </div>
              </div>:null}
                  {data.step_name==='import_txn' && this.state.is_prev_month===false?
                      <div>
                          {this.state.curr_step_num === data.step_num ?
                              <div className="top--2-m st-min-h">
                                  <div className="col-md-8">
                                      <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                                      <h5>{data.step_display_name}</h5>
                                      {/*<p className="font-10">Download Beneficiary file from Bank portal</p>*/}
                                  </div>
                                  <div className="col-md-4">
                                      {/*<button type="button" className="primary rc-history-btn" role="button"  >History</button>*/}
                                      {/*&nbsp; &nbsp;*/}
                                      <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'import_txn', data.step_num, data.invoice_process_id,'')}  >Next</button>
                                      <div className="clearfix"></div>
                                      <BeatLoader
                                          css={override}
                                          sizeUnit={"px"}
                                          size={5}
                                          color={'#123abc'}
                                          loading={this.state.loading}
                                      />

                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="col-md-12 s-r-con">
                                      {this.state.userSubGroupName ==='Admin' && this.state.userType ==='Internal'?
                                          <div className="">
                                              <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center"}} onClick={this.get_current_state.bind(this,'import_txn', data.step_num, data.invoice_process_id,'import-transaction')}>Import Transaction</Button></div>
                                          </div>: null}
                                  </div>

                                  <div className="clearfix"></div>

                              </div>: null}
                      </div>:null}

                  {data.step_name==='import_churn_utid' && this.state.is_prev_month===false?
                      <div>
                          {this.state.curr_step_num === data.step_num ?
                              <div className="top--2-m st-min-h">
                                  <div className="col-md-8">
                                      <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                                      <h5>{data.step_display_name}</h5>
                                      {/*<p className="font-10">Download Beneficiary file from Bank portal</p>*/}
                                  </div>
                                  <div className="col-md-4">
                                     
                                      <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'import_churn_utid', data.step_num, data.invoice_process_id,'')}  >Next</button>
                                      <div className="clearfix"></div>
                                      

                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="col-md-12 s-r-con">
                                  <div className="col-sm-7 col-sm-offset-4">
                                        <a href={Churned_Utid} download="Churned_Utid.csv" className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                                  </div>
                                      <Dropzone multiple={false}
                                                onDrop={this.onPreviewDropUTIDs}>
                                          {({ getRootProps, getInputProps }) => (
                                              <section>
                                                  <div className="col-md-3"></div>
                                                  <div className="col-md-6 text-center  m-tb-10 p-0" style={{background:'#D3D3D3', marginTop:'50px'}}>

                                                      <div style={{ outlineStyle: 'none' }} {...getRootProps()}>
                                                          <input {...getInputProps()} />
                                                          <div className="col-md-12 m-tb-20" style={{ color: '#000000' }}>
                                                             
                                                              <p className="">Drop the CSV file here to upload the data.</p>
                                                              <p className="font-10">&nbsp;</p>
                                                              
                                                              <p className="font-10">&nbsp;</p>
                                                              <p className="font-10" style={{color:'#000000'}}>{this.state.UTIDs_file_status}</p>

                                                          </div>
                                                         
                                                      </div>
                                                      <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center", }} onClick={this.get_current_state.bind(this,'import_churn_utid', data.step_num, data.invoice_process_id,'import_churn_utid')}>Upload</Button></div>
                                                      <div>&nbsp;</div>
                                                      <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={5}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                  </div>
                                                  <div className="col-md-3"></div>

                                              </section>
                                          )}
                                      </Dropzone>
                                  </div>
                                  <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'import_churn_utid', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                         
                      </div>
                      <div className="clearfix"></div>

                              </div>: null}
                      </div>:null}
                  {data.step_name==='import_ntcr_data' && this.state.is_prev_month===false?
                      <div>
                          {this.state.curr_step_num === data.step_num ?
                              <div className="top--2-m st-min-h">
                                  <div className="col-md-8">
                                      <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                                      <h5>{data.step_display_name}</h5>
                                     
                                  </div>
                                  <div className="col-md-4">
                                      {/*<button type="button" className="primary rc-history-btn" role="button"  >History</button>*/}
                                      {/*&nbsp; &nbsp;*/}
                                      <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'import_ntcr_data', data.step_num, data.invoice_process_id,'')}  >Next</button>
                                      <div className="clearfix"></div>
                                      

                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="col-md-12">
                                  <div className="col-sm-7 col-sm-offset-4">
                                        <a href={NTCR} download="NTCR.csv" className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                                  </div>
                                      <Dropzone multiple={false}
                                                onDrop={this.onPreviewDropNtcr}>
                                          {({ getRootProps, getInputProps }) => (
                                              <section>
                                                  <div className="col-md-3"></div>
                                                  <div className="col-md-6 text-center  m-tb-10 p-0" style={{background:'#D3D3D3', marginTop:'50px'}}>

                                                      <div style={{ outlineStyle: 'none' }} {...getRootProps()}>
                                                          <input {...getInputProps()} />
                                                          <div className="col-md-12 m-tb-20" style={{ color: '#000000' }}>
                                                          <p className="">Drop the CSV file here to upload the data.</p>
                                                              <p className="font-10">&nbsp;</p>
                                                              <p className="font-10">&nbsp;</p>
                                                              <p className="font-10" style={{color:'#000000'}}>{this.state.upload_ntcr_data_status}</p>
                                                             
                                                          </div>
                                                      </div>
                                                      <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center", }} onClick={this.get_current_state.bind(this,'import_ntcr_data', data.step_num, data.invoice_process_id,'import_ntcr_data')}>Upload</Button></div>
                                                      <div>&nbsp;</div>
                                                      <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={5}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                  </div>
                                                  <div className="col-md-3"></div>
                                              </section>
                                          )}
                                      </Dropzone>
                                  </div>
                                  
                                  <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'import_ntcr_data', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                      </div>
                      <div className="clearfix"></div>
                              </div>: null}
                      </div>:null}

                  {data.step_name==='import_churn_btid' && this.state.is_prev_month===false?

                      <div>

                          {this.state.curr_step_num === data.step_num ?
                      <div className="top--2-m st-min-h">
                          <div className="col-md-8">
                              <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                              <h5>{data.step_display_name}</h5>
                              
                          </div>
                          <div className="col-md-4">
                              {/*<button type="button" className="primary rc-history-btn" role="button" >History</button>*/}
                              {/*&nbsp; &nbsp;*/}
                              <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'import_churn_btid', data.step_num, data.invoice_process_id,'')}  >Next</button>
                              <div className="clearfix"></div>
                              
                          </div>
                          <div className="clearfix"></div>
                          <div className="col-md-12">
                            <div className="col-sm-7 col-sm-offset-4">
                                <a href={Churned_Btid} download="Deactivated_Btid.csv" className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                            </div>
                              <Dropzone multiple={false}
                                        onDrop={this.onPreviewDrop}>
                                  {({ getRootProps, getInputProps }) => (
                                      <section>
                                          <div className="col-md-3"></div>
                                                <div className="col-md-6 text-center  m-tb-10 p-0" style={{background:'#D3D3D3', marginTop:'50px'}}>

                                                  <div style={{ outlineStyle: 'none' }} {...getRootProps()}>
                                                  <input {...getInputProps()} />
                                                  <div className="col-md-12 m-tb-20" style={{ color: '#000000' }}>
                                                    <p className="">Drop the CSV file here to upload the data.</p>
                                                        <p className="font-10">&nbsp;</p>
                                                        <p className="font-10">&nbsp;</p>
                                                        <p className="font-10" style={{color:'#000000'}}>{this.state.upload_btid_data_status}</p>
                                                        
                                                    </div>
                                                </div>
                                                <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center", }} onClick={this.get_current_state.bind(this,'import_churn_btid', data.step_num, data.invoice_process_id,'import_churn_btid')}>Upload</Button></div>
                                                      <div>&nbsp;</div>
                                                      <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={5}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                  </div>
                                                  <div className="col-md-3"></div>
                                      </section>
                                  )}
                              </Dropzone>
                          </div>
                          <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'import_churn_btid', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                      </div>
                      <div className="clearfix"></div>
                        </div>: null}
                      </div>:null}
                  {data.step_name==='gst_mapping' && this.state.is_prev_month===false?
                      <div>
                          {this.state.curr_step_num === data.step_num ?
                      <div className="top--2-m st-min-h">
                          <div className="col-md-10">
                              <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                              <h5>{data.step_display_name}</h5>
                              <p className="font-10">{this.state.utid_gst_missing} UTIDs are not mapped with GSTs.</p>
                              {/* <p className="font-10">Please download the UTIDs list from "Action Overview" and Upload the same file with GST column filled.</p> */}
                          </div>
                          <div className="col-md-2">
                              {/*<button type="button" className="primary rc-history-btn" role="button" >History</button>*/}
                              {/*&nbsp; &nbsp;*/}
                              <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'gst_mapping', data.step_num, data.invoice_process_id, '')}  >Next</button>
                              <div className="clearfix"></div>
                              
                          </div>
                          <div className="clearfix"></div>
                          <div className="col-md-12">
                                <Tabs>
                                    <TabList>
                                        <Tab >GST</Tab>
                                        <Tab >Party Code</Tab>
                                        
                                    </TabList>

                                    <TabPanel>
                                    <div className="col-sm-7 col-sm-offset-4">
                                        <a href={gstDetails} download="GST_details.csv" className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                                        </div>
                                    <Dropzone multiple={false}
                                        onDrop={this.onPreviewDropGst}>
                                  {({ getRootProps, getInputProps }) => (
                                      <section>
                                          <div className="col-md-3"></div>
                                                <div className="col-md-6 text-center  m-tb-10 p-0" style={{background:'#D3D3D3', marginTop:'50px'}}>

                                                  <div style={{ outlineStyle: 'none' }} {...getRootProps()}>
                                                  <input {...getInputProps()} />
                                                  <div className="col-md-12 m-tb-20" style={{ color: '#000000' }}>
                                                    <p className="">Drop the CSV file here to upload the data.</p>
                                                        <p className="font-10">&nbsp;</p>
                                                        <p className="font-10">&nbsp;</p>
                                                        <p className="font-10" style={{color:'#000000'}}>{this.state.upload_gst_data_status}</p>
                                                        
                                                    </div>
                                                </div>
                                                <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center", }} onClick={this.get_current_state.bind(this,'gst_mapping', data.step_num, data.invoice_process_id,'gst_upload')}>Upload</Button></div>
                                                      <div>&nbsp;</div>
                                                      <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={5}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                  </div>
                                                  <div className="col-md-3"></div>
                                                  <div className ="clearfix"></div>
                                      </section>
                                  )}
                              </Dropzone>
                                    </TabPanel>
                                    <TabPanel>
                                    <div className="col-sm-7 col-sm-offset-4">
                                        <a href={gstMap} download="GST_map.csv" className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                                        </div>
                                    <Dropzone multiple={false}
                                        onDrop={this.onPreviewDropPartyCode}>
                                  {({ getRootProps, getInputProps }) => (
                                      <section>
                                          <div className="col-md-3"></div>
                                                <div className="col-md-6 text-center  m-tb-10 p-0" style={{background:'#D3D3D3', marginTop:'50px'}}>

                                                  <div style={{ outlineStyle: 'none' }} {...getRootProps()}>
                                                  <input {...getInputProps()} />
                                                  <div className="col-md-12 m-tb-20" style={{ color: '#000000' }}>
                                                    <p className="">Drop the CSV file here to upload the data.</p>
                                                        <p className="font-10">&nbsp;</p>
                                                        <p className="font-10">&nbsp;</p>
                                                        <p className="font-10" style={{color:'#000000'}}>{this.state.upload_party_code_data_status}</p>
                                                        
                                                    </div>
                                                </div>
                                                <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center", }} onClick={this.get_current_state.bind(this,'gst_mapping', data.step_num, data.invoice_process_id,'party_code_upload')}>Upload</Button></div>
                                                      <div>&nbsp;</div>
                                                      <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={5}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                  </div>
                                                  <div className="col-md-3"></div>
                                                  <div className ="clearfix"></div>
                                      </section>
                                  )}
                              </Dropzone>
                                    </TabPanel>
                                </Tabs>
                  
                          </div>
                          
                          <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'gst_mapping', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                      </div>
                      <div className="clearfix"></div>
                          
                          
                      </div>: null}
                      </div>:null}
                  {data.step_name==='run_invoice' && this.state.is_prev_month===false?
                      <div>
                          {this.state.curr_step_num === data.step_num ?
                      <div className="top--2-m st-min-h">
                          <div className="col-md-8">
                              <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                              <h5>{data.step_display_name}</h5>
                              {/*<p className="font-10">To reconcile the transaction.</p>*/}
                          </div>
                          <div className="col-md-4">
                              {/*<button type="button" className="primary rc-history-btn" role="button" >History</button>*/}
                              {/*&nbsp; &nbsp;*/}
                              <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_run_invoice_status.bind(this,'run_invoice', data.step_num, data.invoice_process_id, 'run_invoice')}  >Next</button>
                              {/* <BeatLoader
                                  css={override}
                                  sizeUnit={"px"}
                                  size={5}
                                  color={'#123abc'}
                                  loading={this.state.loading}
                              /> */}
                          </div>
                          <div className="clearfix"></div>
                          <div className="col-md-12  border-right-gradient"  style={{minHeight:250}}>
                              {/* {this.state.invoice_running_status==='pending' || this.state.invoice_running_status==='failed' || this.state.invoice_running_status==='stopped'? */}
                              <React.Fragment>
                              <div className="accept-st-con">
                                  <p className=""><input type="checkbox" onChange={this.handleCheckbox_run_invoice.bind(this)} checked={this.state.accept_run_invoice}/> &nbsp; &nbsp; I confirm to run the invoice for the month of {this.state.month_name} {this.state.year_name}.</p>

                              </div>
                              <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center", }} onClick={this.get_current_state.bind(this,'run_invoice', data.step_num, data.invoice_process_id,'run_invoice')}>Run Invoice</Button></div>
                                    <div>&nbsp;</div>
                                    <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={5}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                                </React.Fragment>
                                {/* :null} */}
                                <React.Fragment>
                                    <div className="accept-st-con">
                                        <p className="">Invoice Run Status: {this.state.invoice_running_status}</p>
                                    </div>
                                </React.Fragment>
                                
                          </div>
                         
                          <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'run_invoice', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                      </div>
                      <div className="clearfix"></div>

                       </div>: null}
                      </div>:null}

                  {data.step_name==='download_inv_file' && this.state.is_prev_month===false?
                      <div>
                          {this.state.curr_step_num === data.step_num ?
                      <div className="top--2-m st-min-h">
                          <div className="col-md-8">
                              <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                              <h5>{data.step_display_name}</h5>
                              {/*<p className="font-10">To reconcile the transaction.</p>*/}
                          </div>
                          <div className="col-md-4">
                              {/*<button type="button" className="primary rc-history-btn" role="button" >History</button>*/}
                              {/*&nbsp; &nbsp;*/}
                              <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'download_inv_file', data.step_num, data.invoice_process_id, '')}  >Next</button>
                              
                          </div>
                          <div className="clearfix"></div>
                          <div className="col-md-6  border-right-gradient">
                              <div className="col-md-12 m-tb-20" style={{ color: '#000000', textAlign:'center',background:'#D3D3D3', marginTop:'50px' }}>
                                  
                                      <p>&nbsp;</p><p>&nbsp;</p>
                                      <p className="" style={{color:'#000000'}}>Download the invoice Files</p>
                                      <p className="font-10">&nbsp;</p>
                                      <div style={{textTransform:"capitalize", textAlign:"center"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center",marginTop:'70px' }} onClick={this.downloadInvoiceFile.bind(this,'download_inv_file', data.step_num, data.invoice_process_id,'')}>Download</Button></div>
                                  
                                  <br />
                                  
                                  <br />
                              </div>
                          </div>
                          <div className="col-md-6 s-r-con">
                          <div style={{textTransform:"capitalize", textAlign:"center", marginTop:"100px"}}><Button color="primary" className="m-t-10" style={{textTransform:"capitalize", textAlign:"center",marginTop:'70px' }} onClick={this.get_current_state.bind(this,'download_inv_file', data.step_num, data.invoice_process_id,'download_inv_file')}>Generate Invoice Files</Button></div>
                                    <div>&nbsp;</div>
                                    <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={5}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                          </div>
                          {this.state.generate_invoice_file==='success'?
                            <div className="font-10 color-red-italic">Invoice file has been generated.</div>:
                            null
                          }
                          {this.state.generate_invoice_file==='running'?
                            <div className="font-10 color-red-italic">Waiting for generate invoice file.</div>:
                            null
                          }
                            
                          
                          <div className="clearfix"></div>
                          <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'download_inv_file', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                      </div>
                      <div className="clearfix"></div>
                      </div>: null}
                      </div>:null}
                  {data.step_name==='invoice_sent' && this.state.is_prev_month===false?
                      <div>
                      {this.state.curr_step_num === data.step_num ?
                  <div className="top--2-m st-min-h">
                      <div className="col-md-8">
                          <p className="font-10 margin-top-20">STEP {data.step_num}</p>
                          <h5>{data.step_display_name}</h5>
                          {/*<p className="font-10">To reconcile the transaction.</p>*/}
                      </div>
                      <div className="col-md-4">
                          {/*<button type="button" className="primary rc-history-btn" role="button" >History</button>*/}
                          {/*&nbsp; &nbsp;*/}
                          {this.state.curr_step_status==='initiated' && this.state.curr_step_name==='invoice_sent'?
                          <button type="button" className="primary rc-next-btn" role="button" onClick={this.get_current_state.bind(this,'invoice_sent', data.step_num, data.invoice_process_id, '')}  >Next</button>
                          :null}
                          <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading}
                          />
                      </div>
                      <div className="clearfix"></div>
                      <div className="col-md-12  border-right-gradient"  style={{minHeight:250}}>
                          <div className="accept-st-con">
                              {this.state.curr_step_status==='completed' && this.state.curr_step_name==='invoice_sent'?
                              <p className=""> &nbsp; &nbsp; The invoices are shared with all the parties.</p>
                              :<p className=""><input type="checkbox" onChange={this.handleCheckbox_send_invoice.bind(this)} checked={this.state.accept_send_invoice}/> &nbsp; &nbsp; I confirm that the invoices are shared with all the parties.</p>
                              }
                          </div>
                      </div>
                      <div className="col-md-4 pull-right" style={{marginBottom:"20px"}}>
                            <button type="button" className="primary rc-next-btn" role="button" onClick={this.showAlert.bind(this,'invoice_sent', data.step_num, data.invoice_process_id, 'prev')}  >Previous</button>
                        
                           <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={5}
                              color={'#123abc'}
                              loading={this.state.loading1}
                          />
                      </div>
                      <div className="clearfix"></div>
                      <div className="clearfix"></div>

                   </div>: null}
                  </div>:null}

              </div>
            )
        },);

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "34px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "34px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),

        };
        return (
            <>
                <div className="content longcontent" id="main_data">
                    <div className="card-query-builder">
                        <NotificationSystem ref="notificationSystem" style={style} />
                       
                        <div className="col-md-12 m-t-10">
                            <div className="card " style={{marginBottom:"15px"}}>
                                <div className="col-md-2">
                                    <h5 style={{padding:"0px", fontSize:"14px"}} >Action overview</h5>
                                </div>

                                    {this.state.userSubGroupName ==='Admin' && this.state.userType ==='Internal'?
                                        <div className="col-md-6">
                                            <div className="s-l-d"> Month: </div>
                                            <div className="s-r-d customDatePickerWidth">

                                                    <Select name="month"
                                                            value={this.state.monthValue}
                                                            styles={customStyles} className="chainLists"
                                                            isClearable={false}
                                                            onChange={this.changeMonth.bind(this)}
                                                            options={monthOptions}
                                                            defaultValue={{value: month_years, label: prevMonth+" "+curr_yr}}
                                                            placeholder="Months"
                                                    />
                                                    <div className="clearfix"></div>

                                            </div>
                                        </div> : null}
                                        <div class="coll-md-4 pull-right dash-sync-con"><span class="dash-data-sync-sp"><span>Running Invoice for {this.state.month_name+" "+this.state.year_name}</span></span></div>

                                <div className="clearfix"></div>
                                <div className="content">

                                    <div className="row" style={{marginBottom:"-15px"}}>

                                    <div className="col-md-2 border-right-gradient">
                                        <div className="act_nu kpi-green-color">{this.state.total_txn===null?"--":this.state.total_txn}</div>
                                        <a href="#" >
                                            <div className="act_icon"><img src={upRight} alt="arrow" /></div>
                                        </a>
                                        <div className="clearfix"></div>
                                        <p>Total Unipay Txns</p>
                                    </div>
                                   
                                    <div className="col-md-2 border-right-gradient">
                                        <div className="act_nu kpi-red-color">{this.state.churned_utid===null?"--":this.state.churned_utid}</div>
                                        <a href="#" onClick={this.downloadKpi.bind(this, 'chruned_utid')}>
                                            <div className="act_icon"><img src={upRight} alt="arrow" /></div>
                                        </a>
                                        <div className="clearfix"></div>
                                        <p>UTIDs Churned</p>
                                    </div>
                                    <div className="col-md-2 border-right-gradient">
                                        <div className="act_nu kpi-green-color">{this.state.new_utid_configured===null?"--":this.state.new_utid_configured}</div>
                                        <a href="#" onClick={this.downloadKpi.bind(this, 'new_utid')}>
                                            <div className="act_icon"><img src={upRight} alt="arrow" /></div>
                                        </a>
                                        <div className="clearfix"></div>
                                        <p>New UTIDs Configured</p>
                                    </div>
                                    <div className="col-md-2 border-right-gradient">
                                        <div className="act_nu kpi-red-color">{this.state.churned_btid===null?"--":this.state.churned_btid}</div>
                                        <a href="#" onClick={this.downloadKpi.bind(this,'churned_btid')}>
                                            <div className="act_icon"><img src={upRight} alt="arrow" /></div>
                                        </a>
                                        <div className="clearfix"></div>
                                        <p>Deactivated BTID's</p>
                                    </div>
                                    <div className="col-md-2 border-right-gradient">
                                        <div className="act_nu kpi-red-color">{this.state.utid_gst_missing===null?"--":this.state.utid_gst_missing}</div>
                                        <a href="#" onClick={this.downloadKpiDetails.bind(this,'download')}>
                                            <div className="act_icon"><img src={upRight} alt="arrow" /></div>
                                        </a>
                                        <div className="clearfix"></div>
                                        <p>UTIDS GST Missing</p>
                                    </div>

                                    </div>

                                </div>
                            </div>
                            <div className="row">

                                <div className="clearfix"></div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="rc-steps rc-steps-vertical">
                                            <h5>Invoice Generation Steps</h5>

                                            {steps_menu_bind}

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="card">
                                        {steps_content_bind}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <ModalD visible={this.state.model_Mismach} width="300" height="100" effect="fadeInUp">
                            <div className="download-popup-model">
                                <div className="message-content">
                                    {this.state.file_url==''?
                                        <div>
                                            <p>Generating...</p>
                                            <a href="javascript:void(0);" onClick={() => this.closeMismachModal()}>
                                                <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                            </a>
                                        </div>
                                        :
                                        <div className="dwnloadLink">
                                            <a href="#" onClick={this.downloadFile.bind(this,"", "")}>
                                                <i className="fa fa-download" aria-hidden="true"></i>Download
                                            </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <a href="javascript:void(0);" onClick={() => this.closeMismachModal()}>
                                                <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </ModalD>
                      

                    </div>
                </div>
            </>

        );
    }
}


export default InvoiceProcess
